import actionTypes from '../actions/action-types';

const initialState = {
  entities: {},
  ids: [],
  selectedId: null,
  isPrivilegeTemplatesListLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRIVILEGE_TEMPLATES_REQUEST:
      return {
        ...state,
        isPrivilegeTemplatesListLoading: true,
      };

    case actionTypes.FETCH_PRIVILEGE_TEMPLATES_FAILURE:
      return {
        ...state,
        isPrivilegeTemplatesListLoading: false,
      };

    case actionTypes.FETCH_PRIVILEGE_TEMPLATES_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const entities = {};

      action.list.forEach((template) => {
        entities[template.id] = template;
      });

      return {
        entities,
        ids: Object.keys(entities),
        selectedId: Object.keys(entities)[0],
        isPrivilegeTemplatesListLoading: false,
      };

    case actionTypes.CREATE_PRIVILEGE_TEMPLATE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const entitiesAfterCreate = {
        [action.template.id]: { ...action.template },
        ...state.entities,
      };

      return {
        ...state,
        entities: entitiesAfterCreate,
        ids: Object.keys(entitiesAfterCreate),
      };

    case actionTypes.UPDATE_PRIVILEGE_TEMPLATE_SUCCESS:
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.template.id]: { ...action.template },
        },
      };

    case actionTypes.SELECT_PRIVILEGE_TEMPLATE:
      return {
        ...state,
        selectedId: action.id,
      };

    case actionTypes.DELETE_PRIVILEGE_TEMPLATE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const entitiesAfterDelete = { ...state.entities };

      Object.keys(entitiesAfterDelete).forEach((id) => {
        if (id === action.id) {
          delete entitiesAfterDelete[action.id];
        }
      });

      return {
        entities: entitiesAfterDelete,
        ids: state.ids.filter((id) => id !== action.id),
        selectedId: Object.keys(entitiesAfterDelete)[0],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/reducers/privilege-templates.reducer.js